/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineObject7 model module.
 * @module model/InlineObject7
 * @version 1.0.0
 */
class InlineObject7 {
    /**
     * Constructs a new <code>InlineObject7</code>.
     * @alias module:model/InlineObject7
     * @param files {File} New document file (max 20 MB)
     */
    constructor(files) { 
        
        InlineObject7.initialize(this, files);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, files) { 
        obj['files'] = files;
    }

    /**
     * Constructs a <code>InlineObject7</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineObject7} obj Optional instance to populate.
     * @return {module:model/InlineObject7} The populated <code>InlineObject7</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineObject7();

            if (data.hasOwnProperty('files')) {
                obj['files'] = ApiClient.convertToType(data['files'], File);
            }
            if (data.hasOwnProperty('more_info')) {
                obj['more_info'] = ApiClient.convertToType(data['more_info'], 'String');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
        }
        return obj;
    }


}

/**
 * New document file (max 20 MB)
 * @member {File} files
 */
InlineObject7.prototype['files'] = undefined;

/**
 * Additional information
 * @member {String} more_info
 */
InlineObject7.prototype['more_info'] = undefined;

/**
 * Comments
 * @member {String} comments
 */
InlineObject7.prototype['comments'] = undefined;






export default InlineObject7;

